<script lang="ts">
  import MessagingPage from "@modern/components/retailer/MessagingCenter/Containers/Page.svelte";
  import { HttpPromise, HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";
  import { params } from "@roxi/routify";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";

  const load = async () => {
    let res = await HttpPromiseWithEntireResponse({
      method: "GET",
      url: "/api/retailer/message_groups",
      data: $params,
    });
    let messagesRes;
    if (res.ok) {
      messagesRes = await res.json();
      messagesRes.headers = {
        get: function (h) {
          return res.headers.get(h);
        },
      };
    }

    let connectedReps = await HttpPromise({
      method: "GET",
      url: "/api/retailer/distributors/connected_reps",
    });
    return { messagesRes, connectedReps };
  };

</script>

{#await load()}
  <Spinner />
{:then data}
  <MessagingPage
    messagesRes={data.messagesRes}
    connectedReps={data.connectedReps}
    searchQuery={$params.search}
    page={Number($params.page) || 1}
    salesRepId={Number($params.salesRepId)}
  />
{/await}
